<template>
  <div :class="$style.gallery">
    <ProductGallery
      v-if="images"
      :images="images"
      @open-modal="shouldOpenModal = true"
    />
    <BaseModal
      :is-open="shouldOpenModal"
      overlay-color="rgba(255, 255, 255, 0.8)"
      @request-close="shouldOpenModal = false"
    >
      <div :class="$style.modalContainer">
        <div :class="$style.modal">
          <BaseButton
            :class="$style.closeBtn"
            :aria-label="localizedStrings['close-modal'] || 'Close Modal'"
            presentation="strip"
            @click.stop="shouldOpenModal = false"
          >
            <div :class="$style.closeBtnWrapper">
              <IconTimes :class="$style.timesIcon" alt="" />
            </div>
          </BaseButton>
          <ProductGallery
            :is-modal="true"
            :images="images"
            :has-marketing-materials="hasMarketingMaterials"
            @open-modal="shouldOpenModal = true"
            @request-close="shouldOpenModal = false"
          />
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script setup lang="ts">
import type { Asset } from 'contentful'

const { localizedStrings } = useLocalizedStrings()

defineProps<{
  images?: (Asset | undefined)[]
  hasMarketingMaterials?: boolean
}>()

// Data
const shouldOpenModal = ref(false)
</script>

<style lang="scss" module>
.gallery {
  margin-bottom: 35px;

  @include media('sm') {
    flex: 0 1 415px;
    margin-bottom: 0;
    margin-right: 60px;
  }
}

.modalContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-width: 900px;
  width: 90%;
  margin: 0 auto;
}

.modal {
  position: relative;
  width: 100%;
  max-height: 80%;
}

.closeBtn {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
}

.closeBtnWrapper {
  align-items: center;
  background-color: var(--purple);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 39px;
  justify-content: center;
  width: 39px;
}

.timesIcon {
  color: var(--white);
  width: 25px;
  height: 25px;
}
</style>
